module.exports = __webpack_public_path__ + "static/media/jpxs.9f69804a.png";